import NewsroomMediaOneContainer from "./container/NewsroomMediaOneContainer";
export default NewsroomMediaOneContainer;
